import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Managment } from 'src/app/interfaces/managment';
import { ErrorService } from 'src/app/services/error.service';
import { ManagmentService } from 'src/app/services/managment.service';

@Component({
  selector: 'app-managment',
  templateUrl: './managment.component.html',
  styleUrls: ['./managment.component.css']
})
export class ManagmentComponent implements OnInit {
  listManagments: Managment[] = [];
  loading = false;

  constructor(
    private _managmentService: ManagmentService,
    private toastr: ToastrService,
    private _errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.getListManagments();
  }

  getListManagments() {
    this.loading = true;

    this._managmentService.getListManagments().subscribe({
      next: (data: Managment[]) => {
        this.listManagments = data;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al obtener la lista de gestiones:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  deleteManagment(id: number) {
    this.loading = true;
    this._managmentService.deleteManagment(id).subscribe({
      next: () => {
        this.getListManagments();
        this.toastr.warning('La gestion fue eliminada con exito', 'Gestion eliminada');
      },
      error: (error) => {
        console.error('Error al eliminar la gestion:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }
}
